import { render, staticRenderFns } from "./milestone-sidebar.vue?vue&type=template&id=11360234&scoped=true&"
import script from "./milestone-sidebar.vue?vue&type=script&lang=ts&"
export * from "./milestone-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-sidebar.vue?vue&type=style&index=0&id=11360234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11360234",
  null
  
)

export default component.exports